import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import ServicesBg from "../assets/images/services-bg.jpg";
import Breadcrumbs from "../components/Breadcrumbs";
import Counter from "../components/Counter";
import Footer from "../components/Footer";
import SeconadaryBtn from "../components/SeconadaryBtn";
import Welcome from "../assets/images/welcome.jpg";
import CompImg from "../assets/images/compImg.jpg";
import Service3 from "../assets/images/service3.jpg";
import Service4 from "../assets/images/service4.jpg";
import Service5 from "../assets/images/service5.jpg";
import Service6 from "../assets/images/service6.jpg";
import Service7 from "../assets/images/service7.jpg";
import CareNavigate from "../assets/images/careNavigate.jpg";
import Wellness from "../assets/images/welness.jpg";
import Service10 from "../assets/images/service10.jpg";
import Service11 from "../assets/images/service11.jpg";
import AppointmentForm from "../components/AppointmentForm";

export default function Services() {
  const [hovered, setHovered] = useState("about");
  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "Services",
      active: hovered === "services" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("services"),
      onMouseLeave: () => setHovered("services"),
    },
  ];

  const servicesList = [
    {
      id: 1,
      title: "Diabetes & Kidney Protection Check",
      amount: "Free",
      description: "Click the purchase service below to register",
      image: Welcome,
      reverse: false,
      purchaseLink: "/create_user",
    },
    {
      id: 2,
      title: "Welcome to Verimed",
      amount: "Free",
      description: "Sample service to walkthrough purchase flow.",
      image: Welcome,
      reverse: false,
      purchaseLink: "/create_user",
    },
    {
      id: 3,
      title: "Comprehensive Physician Intake (In-Person)",
      amount: "$125 USD",
      description:
        "Required for all new patients. Includes full medical history, physical or virtual exam, and personalized treatment plan.",
      image: CompImg,
      reverse: false,
      purchaseLink: "https://buy.stripe.com/4gMeVffCz1cecCogoz4ko00",
    },
    {
      id: 4,
      title: "In-Home Follow-up Physician Visit",
      amount: "$95 USD",
      description:
        "Private visit by a licensed physician at home or residence. Includes exam, medication review, and care plan updates.",
      image: Service3,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/28EeVfbmj3km7i44FR4ko01",
    },
    {
      id: 5,
      title: "Virtual Physician Visit",
      amount: "$55 USD",
      description:
        "Video consultation ideal for follow-up visits, chronic condition management, or medication refills.",
      image: Service4,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/aFa9AVeyv5su6e03BN4ko02",
    },
    {
      id: 6,
      title: "Nurse Wellness Check",
      amount: "$50 USD per visit",
      description:
        "Routine nursing visit to monitor vitals, ensure medication adherence, and provide family wellness updates.",
      image: Service5,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/5kQeVf4XVdZ0bykc8j4ko03",
    },
    {
      id: 7,
      title: "Rehydration & IV Fluid Therapy",
      amount: "$60 USD per session",
      description:
        "At-home IV fluid administration with nursing monitoring and basic lab checks (if needed).",
      image: Service6,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/8x200l61ZcUWbykc8j4ko04",
    },
    {
      id: 8,
      title: "Infusion Therapy for Prescribed Medication",
      amount: "$90 USD + cost of medication",
      description:
        "Administration of prescribed IV therapy under physician supervision.",
      image: Service7,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/eVqeVf3TR3km8m88W74ko05",
    },
    {
      id: 9,
      title: "Care Management & Navigation",
      amount: "$100 USD / month",
      description:
        "Ongoing care coordination for families abroad — includes appointment scheduling, hospital communication, and biweekly family updates.",
      image: CareNavigate,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/dRmcN7fCz7ACeKwgoz4ko06",
    },
    {
      id: 10,
      title: "Wellness Coaching",
      amount: "$75 USD/session",
      description:
        "Virtual consultation focused on balanced living, stress management, and nutrition for chronic disease prevention and management.",
      image: Wellness,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/cNi9AV1LJbQSaugc8j4ko07",
    },
    {
      id: 11,
      title: "Diabetes Coaching & Chronic Illness Management",
      amount: "$115 USD/session",
      description:
        "Virtual consultation and coaching focused on diabetes care, diet, nutrition, weight and lifestyle management.",
      image: Service10,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/00w4gB4XVg781XKb4f4ko08",
    },
    {
      id: 12,
      title: "Live-in Family Wellness Nurse",
      amount: "$495 USD/month",
      description:
        "This is nurse trained to deliver restorative care, preventive wellness, activities of daily living and supportive compassionate in-home care. The nurse will move in and live-in at your loved one’s home in Cameroon providing in home care. This is like assisted living services brought into the home.",
      image: Service11,
      reverse: true,
      purchaseLink: "https://buy.stripe.com/7sY8wReyvbQS31O7S34ko09",
    },
    {
      id: 13,
      title: "Diabetes & Metabolic Wellness Program",
      amount: "Free",
      description:
        "This is a free service designed to support individuals challenged with diabetes and metabolic conditions. Through diabetes education and lifestyle counseling supported by US based physicians and nutrition professionals with structured oversight by the VeriMED Cameroon care team, this program will strengthen community-based chronic disease support fro patients and care partners.",
      image: Welcome,
      reverse: false,
      purchaseLink: "create_user",
    },
  ];

  return (
    <div className="service_container">
      <Header />

      {/* Hero Section */}
      <div className="service_hero_section">
        {/* Breadcrumbs */}
        <div className="service_breadcrumb_wrapper">
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            minHeight: "100vh",
            zIndex: -2,
          }}
        >
          <div
            style={{
              backgroundImage: `url(${ServicesBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              transition: "opacity 1s ease-in-out",
            }}
          />
        </div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            minHeight: "100vh",
            background: "linear-gradient(180deg, #00000000 , #E5EFEA)",
            zIndex: -1,
          }}
        />

        {/* Hero Content */}
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            marginTop: 50,
          }}
        >
          <p className="service_hero_subtitle">Services</p>
          <h1 className="service_hero_title">Our Services</h1>
          <p className="service_hero_description">
            At VeriMED, we deliver concierge-style healthcare designed for
            seniors in Cameroon, supported by their families abroad. Each
            service is provided by licensed, compassionate professionals and
            coordinated through our secure care platform.
          </p>
        </div>
      </div>

      {/* Counter */}
      <div className="service_counter_wrapper">
        <Counter />
      </div>

      {/* Services List */}
      <div className="service_list_container">
        {servicesList.map((service, index) => (
          <div
            key={service.id}
            className={`service_card ${
              index % 2 === 0 ? "service_row" : "service_row_reverse"
            }`}
          >
            {/* Image */}
            <div className="service_image_wrapper">
              <img
                src={service.image}
                alt={service.title}
                className="service_image"
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </div>

            {/* Content */}
            <div className="service_content">
              <p className="service_title">
                {index + 1}. {service.title}
              </p>
              <p className="service_amount">{service.amount}</p>
              <p className="service_description">{service.description}</p>
              <div className="service_btn_wrapper">
                <SeconadaryBtn
                  label="Purchase Service"
                  onClick={
                    service.purchaseLink === "/create_user"
                      ? () => navigate("/create_user")
                      : () => window.open(service.purchaseLink, "_blank")
                  }
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Appointment Form */}
      <div id="appointment-section" className="service_appointment_wrapper">
        <AppointmentForm />
      </div>

      <Footer />
    </div>
  );
}
